export default __webpack_public_path__ + "static/media/google-play-badge-changed.6925e4e3.png";